import { render, staticRenderFns } from "./LunchRegistration.vue?vue&type=template&id=9706cdcc&scoped=true"
import script from "./LunchRegistration.vue?vue&type=script&lang=js"
export * from "./LunchRegistration.vue?vue&type=script&lang=js"
import style0 from "./LunchRegistration.vue?vue&type=style&index=0&id=9706cdcc&prod&lang=scss&scoped=true"
import style1 from "./LunchRegistration.vue?vue&type=style&index=1&id=9706cdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9706cdcc",
  null
  
)

export default component.exports